module.exports = __webpack_public_path__ + "img/boy-head-back.2807ad81.png";